
<div class="button-container">
  <span class="contract-button" *ngIf="false">
    <button mat-stroked-button color="accent" [disabled]="disabled"  (click)="generatePdfContract(false, true, false)">
      <i class="fa fa-cloud-download-alt" aria-hidden="true"></i> Download PDF Contract
      <i *ngIf="loading" class="ml-2 fas fa-spinner fa-spin"></i>
    </button>
  </span>
  <span class="contract-button" *ngIf="false">
    <button mat-flat-button color="accent" [disabled]="disabled"  (click)="generatePdfContract(true, false, false)">
      <i class="fa fa-paper-plane" aria-hidden="true"></i> Send PDF Contract to Customer
      <i *ngIf="loading" class="ml-2 fas fa-spinner fa-spin"></i>
    </button>
  </span>
  <span class="contract-button" *ngIf="true">
    <button mat-flat-button color="accent" [disabled]="disabled" (click)="generateDocusignContract()">
      <i class="fa fa-paper-plane" aria-hidden="true"></i> Send Docusign Contract
      <i *ngIf="loading" class="ml-2 fas fa-spinner fa-spin"></i>
    </button>
  </span>
  <span class="contract-button" *ngIf="false">
    <button mat-flat-button color="accent" [disabled]="disabled" (click)="generatePdfContract(false, true, true)">
      <i class="fa fa-paper-plane" aria-hidden="true"></i> Preview Docusign Contract
      <i *ngIf="loading" class="ml-2 fas fa-spinner fa-spin"></i>
    </button>
  </span>
  <span class="contract-button">
    <ng-content></ng-content>
  </span>
</div>
